import React, { useState } from 'react'
import { IoCloseOutline, IoMenuOutline } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const [isNavActive, setIsNavActive] = useState(false);

  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };

  const innactivateNav = () => {
    setIsNavActive(false);
  }

  return (
    <div class='navbar'>
        <div class='logo-container'>
            <img src="./images/logo.jpg" alt="Alltime Home Care Services LLC" />
            <p>AllTime <br /> Home Care</p>
        </div>
        
        <ul class={`nav-links ${isNavActive ? 'active' : ''}`}>
            <NavLink to='/' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Home</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/about' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>About Us</li>
            </NavLink>
            <div class='separator'></div>
            <NavLink to='/contact' onClick={()=>innactivateNav()} style={{textDecoration: 'none'}}>
              <li>Contact</li>
            </NavLink>
        </ul>

        <NavLink to='/contact' style={{textDecoration: 'none'}}>
          <div class="cta-button">
              Contact Us
          </div>
        </NavLink>

        <div onClick={toggleNav} class='menu'>
            {isNavActive ? <IoCloseOutline size={40} color='rgb(42, 83, 106)'/> : <IoMenuOutline size={40} color='rgb(42, 83, 106)'/>}
        </div>
    </div>
  )
}

export default Navbar